import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import ErrorBoundaryRoute from "../../../../containers/ErrorBoundaryRoute";

import SalesTaxReport from './components/SalesTaxReport';
import TaxableBreakdownReport from "./components/TaxableBreakdownReport";
import SalesReport from "./components/SalesReport";
import SalesByCategoryReport from "./components/SalesByCategoryReport";
import EmployeeSalesReport from "./components/EmployeeSalesReport";
import LayawayReport from "./components/LayawayReport";
import WorkOrderReport from "./components/WorkOrderReport";
import InvoiceReport from "./components/InvoiceReport";
import YearEndReport from "./components/YearEndReport";
import InventoryReport from "./components/InventoryReport";

export default ({ match, locations, invoicing_enabled}) => (
	<div>
		<Switch>

			<ErrorBoundaryRoute exact path={`${match.url}/inventory_report`}>
				<InventoryReport locations={locations}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/sales_tax`}>
				<SalesTaxReport locations={locations}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/taxable_breakdown`}>
				<TaxableBreakdownReport locations={locations}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/sales_report`}>
				<SalesReport locations={locations} invoicing_enabled={invoicing_enabled}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/sales_by_category`}>
				<SalesByCategoryReport locations={locations}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/employee_sales`}>
				<EmployeeSalesReport locations={locations}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/layaway_report`}>
				<LayawayReport locations={locations} invoicing_enabled={invoicing_enabled}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/work_order_report`}>
				<WorkOrderReport locations={locations}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/invoice_report`}>
				<InvoiceReport locations={locations} invoicing_enabled={invoicing_enabled}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/year_end_report`}>
				<YearEndReport locations={locations}/>
			</ErrorBoundaryRoute>

		</Switch>
	</div>
);
